import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Logo from '../../Components/Logo/Logo';

const NotFoundPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>404 - Page non trouvee | Reze XIII</title>
        <meta name="robots" content="noindex, nofollow" />
      </Helmet>
      <div
        className="not-found-container"
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100vh',
        }}
      >
        <Logo />
        <h1>Page non trouvée</h1>
        <Link
          to="/"
          style={{
            display: 'inline-block',
            marginTop: '2rem',
            padding: '0.5rem 1rem',
            color: '#fffb00',
            backgroundColor: '#000000',
            borderRadius: '5px',
            textDecoration: 'none',
          }}
        >
          Retour à l'accueil
        </Link>
      </div>
    </>
  );
};

export default NotFoundPage;
